import type { SVGProps } from 'react';

interface SVGRProps {
  readonly title?: string;
  readonly titleId?: string;
}

const SvgIconOutlineEye = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={47}
    height={47}
    fill="none"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#32353B"
      d="M35.254 22.83c-.22-.24-5.3-5.83-11.75-5.83s-11.53 5.59-11.75 5.83c-.34.38-.34.95 0 1.33.22.25 5.3 5.84 11.75 5.84s11.53-5.59 11.75-5.83c.33-.38.33-.96 0-1.34m-14.49-3.43a4.93 4.93 0 0 0-2.19 4.1c0 1.71.87 3.21 2.18 4.09-3.12-.88-5.68-3-6.84-4.09 1.16-1.09 3.72-3.22 6.85-4.1m5.49 8.19a4.92 4.92 0 0 0 2.18-4.09c0-1.71-.87-3.21-2.18-4.1 3.12.88 5.68 3.01 6.84 4.1-1.16 1.09-3.72 3.21-6.84 4.09"
    />
    <rect
      width={46.333}
      height={46.333}
      x={0.333}
      y={0.333}
      stroke="#32353B"
      strokeOpacity={0.2}
      strokeWidth={0.667}
      rx={11.667}
    />
  </svg>
);

export default SvgIconOutlineEye;
